// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/OpenSans-Variable.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/NotoSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/RobotoCondensed-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-App-module__appWrapper {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: 26rem 1fr auto;
    grid-template-rows: 100%;
    justify-content: space-between;
    overflow: auto;
    -webkit-user-select: none;
    user-select: none; /* firefox does not ignore -webkit-user-select so make this explicit, see #217 */
}

.src-App-module__map {
    grid-column: 1 / span 3;
    grid-row: 1 / span 1;
}

.src-App-module__sidebar {
    grid-column: 1 / span 1;
    grid-row: 1 / span 1;
    background-color: transparent;
    pointer-events: none;
    z-index: 1;
    align-self: stretch;
}

.src-App-module__popupContainer {
    grid-column: 1 / span 1;
    grid-row: 1 / span 1;
    background-color: transparent;
    pointer-events: none;
    z-index: 2;
    align-self: stretch;

    margin: 0 0.5rem 0 0.5rem;
    overflow: hidden;
    position: relative;
}

.src-App-module__sidebarContent {
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 0.5rem;
    background-color: white;
    max-height: calc(100% - 2rem);
    margin: 0.5rem;

    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);
    pointer-events: all;
    overflow: auto;
}

.src-App-module__onMapRightSide {
    position: relative;
    grid-column: 3 / span 1;
    grid-row: 1 / span 1;
    z-index: 1;

    padding: 0.5rem;
}

.src-App-module__onMapRightSide > div {
    cursor: pointer !important;
}

.src-App-module__onMapRightSide > div {
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);
}

.src-App-module__pathDetails {
    grid-column: 2 / span 2;
    grid-row: 1 / span 1;
    z-index: 1;
    align-self: end;
    overflow: hidden; /* This is important to make the heightgraph shrink */
    margin: 0;
    pointer-events: none;
}

.src-App-module__smallScreenMap {
    grid-row: 1 / span 3;
    grid-column: 1 / span 1;
}

.src-App-module__smallScreenSidebar {
    grid-row: 1 / span 1;
    grid-column: 1 / span 1;
    margin: 0;
    border-radius: 0;
    z-index: 3;
}

.src-App-module__smallScreenMapOptions {
    grid-row: 2 / span 1;
    grid-column: 1 / span 1;
    justify-self: end;
}

.src-App-module__onMapRightSide > div {
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);
}

.src-App-module__smallScreenRoutingResult {
    grid-row: 4 / span 1;
    grid-column: 1 / span 1;
    margin: 0;
    z-index: 2;
    background-color: white;
}

.src-App-module__smallScreenPoweredBy {
    grid-row: 5 / span 1;
    grid-column: 1 / span 1;
    margin: 0;
    border-radius: 0;
    z-index: 2;
}

@media (max-width: 44rem) {
    .src-App-module__appWrapper {
        grid-template-columns: 100%;
        grid-template-rows: auto 0 1fr auto auto;
    }
}

/* mapilion */
@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

/* maptiler */
@font-face {
    font-family: 'Noto Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Condensed';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

.src-App-module__sidebarCloseButton {
    position: absolute;

    color: lightgray !important; /* unsure why !important is necessary here but not in ErrorMessage.module.css for same <Cross/> */

    height: 10px;
    width: 10px;

    right: 7px;
    top: 6px;
}

.src-App-module__sidebarCloseButton:hover {
    color: black !important;
}

.src-App-module__sidebarWhenClosed {
    z-index: 1;
    position: absolute;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);
    padding: 0.25em;
    margin: 0.5em;
}

.src-App-module__sidebarOpenButton svg {
    fill: gray;

    width: 30px;
    height: 24px;
}

.src-App-module__sidebarOpenButton:hover svg {
    fill: black;
}
`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,wBAAwB;IACxB,8BAA8B;IAC9B,cAAc;IACd,yBAAyB;IACzB,iBAAiB,EAAE,gFAAgF;AACvG;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,6BAA6B;IAC7B,oBAAoB;IACpB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,6BAA6B;IAC7B,oBAAoB;IACpB,UAAU;IACV,mBAAmB;;IAEnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,6BAA6B;IAC7B,cAAc;;IAEd,6CAA6C;IAC7C,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;;IAEV,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;IACV,eAAe;IACf,gBAAgB,EAAE,qDAAqD;IACvE,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI;QACI,2BAA2B;QAC3B,wCAAwC;IAC5C;AACJ;;AAEA,aAAa;AACb;IACI,wBAAwB;IACxB,+DAA0D;AAC9D;;AAEA,aAAa;AACb;IACI,wBAAwB;IACxB,+DAAyD;AAC7D;;AAEA;IACI,qBAAqB;IACrB,+DAAuD;AAC3D;;AAEA;IACI,+BAA+B;IAC/B,+DAAgE;AACpE;;AAEA;IACI,kBAAkB;;IAElB,2BAA2B,EAAE,iGAAiG;;IAE9H,YAAY;IACZ,WAAW;;IAEX,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,6CAA6C;IAC7C,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,UAAU;;IAEV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".appWrapper {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: grid;\n    grid-template-columns: 26rem 1fr auto;\n    grid-template-rows: 100%;\n    justify-content: space-between;\n    overflow: auto;\n    -webkit-user-select: none;\n    user-select: none; /* firefox does not ignore -webkit-user-select so make this explicit, see #217 */\n}\n\n.map {\n    grid-column: 1 / span 3;\n    grid-row: 1 / span 1;\n}\n\n.sidebar {\n    grid-column: 1 / span 1;\n    grid-row: 1 / span 1;\n    background-color: transparent;\n    pointer-events: none;\n    z-index: 1;\n    align-self: stretch;\n}\n\n.popupContainer {\n    grid-column: 1 / span 1;\n    grid-row: 1 / span 1;\n    background-color: transparent;\n    pointer-events: none;\n    z-index: 2;\n    align-self: stretch;\n\n    margin: 0 0.5rem 0 0.5rem;\n    overflow: hidden;\n    position: relative;\n}\n\n.sidebarContent {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    border-radius: 0.5rem;\n    background-color: white;\n    max-height: calc(100% - 2rem);\n    margin: 0.5rem;\n\n    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);\n    pointer-events: all;\n    overflow: auto;\n}\n\n.onMapRightSide {\n    position: relative;\n    grid-column: 3 / span 1;\n    grid-row: 1 / span 1;\n    z-index: 1;\n\n    padding: 0.5rem;\n}\n\n.onMapRightSide > div {\n    cursor: pointer !important;\n}\n\n.onMapRightSide > div {\n    background-color: white;\n    border-radius: 0.5rem;\n    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);\n}\n\n.pathDetails {\n    grid-column: 2 / span 2;\n    grid-row: 1 / span 1;\n    z-index: 1;\n    align-self: end;\n    overflow: hidden; /* This is important to make the heightgraph shrink */\n    margin: 0;\n    pointer-events: none;\n}\n\n.smallScreenMap {\n    grid-row: 1 / span 3;\n    grid-column: 1 / span 1;\n}\n\n.smallScreenSidebar {\n    grid-row: 1 / span 1;\n    grid-column: 1 / span 1;\n    margin: 0;\n    border-radius: 0;\n    z-index: 3;\n}\n\n.smallScreenMapOptions {\n    grid-row: 2 / span 1;\n    grid-column: 1 / span 1;\n    justify-self: end;\n}\n\n.onMapRightSide > div {\n    background-color: white;\n    border-radius: 0.5rem;\n    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);\n}\n\n.smallScreenRoutingResult {\n    grid-row: 4 / span 1;\n    grid-column: 1 / span 1;\n    margin: 0;\n    z-index: 2;\n    background-color: white;\n}\n\n.smallScreenPoweredBy {\n    grid-row: 5 / span 1;\n    grid-column: 1 / span 1;\n    margin: 0;\n    border-radius: 0;\n    z-index: 2;\n}\n\n@media (max-width: 44rem) {\n    .appWrapper {\n        grid-template-columns: 100%;\n        grid-template-rows: auto 0 1fr auto auto;\n    }\n}\n\n/* mapilion */\n@font-face {\n    font-family: 'Open Sans';\n    src: url(./fonts/OpenSans-Variable.ttf) format('truetype');\n}\n\n/* maptiler */\n@font-face {\n    font-family: 'Noto Sans';\n    src: url(./fonts/NotoSans-Regular.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url(./fonts/Roboto-Regular.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Condensed';\n    src: url(./fonts/RobotoCondensed-Regular.ttf) format('truetype');\n}\n\n.sidebarCloseButton {\n    position: absolute;\n\n    color: lightgray !important; /* unsure why !important is necessary here but not in ErrorMessage.module.css for same <Cross/> */\n\n    height: 10px;\n    width: 10px;\n\n    right: 7px;\n    top: 6px;\n}\n\n.sidebarCloseButton:hover {\n    color: black !important;\n}\n\n.sidebarWhenClosed {\n    z-index: 1;\n    position: absolute;\n    background-color: white;\n    border-radius: 0.5rem;\n    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);\n    padding: 0.25em;\n    margin: 0.5em;\n}\n\n.sidebarOpenButton svg {\n    fill: gray;\n\n    width: 30px;\n    height: 24px;\n}\n\n.sidebarOpenButton:hover svg {\n    fill: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appWrapper": `src-App-module__appWrapper`,
	"map": `src-App-module__map`,
	"sidebar": `src-App-module__sidebar`,
	"popupContainer": `src-App-module__popupContainer`,
	"sidebarContent": `src-App-module__sidebarContent`,
	"onMapRightSide": `src-App-module__onMapRightSide`,
	"pathDetails": `src-App-module__pathDetails`,
	"smallScreenMap": `src-App-module__smallScreenMap`,
	"smallScreenSidebar": `src-App-module__smallScreenSidebar`,
	"smallScreenMapOptions": `src-App-module__smallScreenMapOptions`,
	"smallScreenRoutingResult": `src-App-module__smallScreenRoutingResult`,
	"smallScreenPoweredBy": `src-App-module__smallScreenPoweredBy`,
	"sidebarCloseButton": `src-App-module__sidebarCloseButton`,
	"sidebarWhenClosed": `src-App-module__sidebarWhenClosed`,
	"sidebarOpenButton": `src-App-module__sidebarOpenButton`
};
export default ___CSS_LOADER_EXPORT___;
